import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconVectorBezier,
  IconBrandYcombinator,
  IconCategory2,
  IconAdjustments,
  IconDevices,
  IconShieldChevron,
  IconHexagons,
} from '@tabler/icons-react'

export const brandModuleKey = 'brand'
export const productModelModuleKey = 'product_model'
export const attributeModuleKey = 'attribute'
export const providerModuleKey = 'provider'
export const deviceModelModuleKey = 'device_model'
export const categoryModuleKey = 'category'

const categoriesRoute: RouteConfig = {
  uid: categoryModuleKey,
  path: 'directory/categories',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/categories')).default,
  }),
}

const createCategoryRoute: RouteConfig = {
  uid: categoryModuleKey,
  path: 'directory/categories/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/directory/categories/create-category'))
      .default,
  }),
}

const editCategoryRoute: RouteConfig = {
  uid: categoryModuleKey,
  path: 'directory/categories/:categoryId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/directory/categories/edit-category'))
      .default,
  }),
}

const brandRoute: RouteConfig = {
  uid: brandModuleKey,
  path: 'directory/brands',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/brands')).default,
  }),
}

const createBrandRoute: RouteConfig = {
  uid: brandModuleKey,
  path: 'directory/brands/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/directory/brands/create-brand')).default,
  }),
}

const editBrandRoute: RouteConfig = {
  uid: brandModuleKey,
  path: 'directory/brands/:brandId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/directory/brands/edit-brand')).default,
  }),
}

const modelRoute: RouteConfig = {
  uid: productModelModuleKey,
  path: 'directory/models',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/models')).default,
  }),
}

const attributeRoute: RouteConfig = {
  uid: attributeModuleKey,
  path: 'directory/attributes',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/attributes')).default,
  }),
}

const createAttributeRoute: RouteConfig = {
  uid: attributeModuleKey,
  path: 'directory/attributes/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/directory/attributes/create-attribute'))
      .default,
  }),
}

const editAttributeRoute: RouteConfig = {
  uid: attributeModuleKey,
  path: 'directory/attributes/:attributeId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/directory/attributes/edit-attribute'))
      .default,
  }),
}

const providerRoute: RouteConfig = {
  uid: providerModuleKey,
  path: 'directory/providers',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/providers')).default,
  }),
}

//------------------------------ device model ------------------------

const deviceModel: RouteConfig = {
  uid: deviceModelModuleKey,
  path: 'directory/device-model',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/directory/device-model')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Directory',
  href: 'directory',
  icon: <IconVectorBezier size={18} />,
  order: 5,
  sub: [
    {
      uid: brandModuleKey,
      title: 'Brands',
      href: 'directory/brands',
      icon: <IconBrandYcombinator size={18} />,
      order: 1,
    },
    {
      uid: categoryModuleKey,
      title: 'Categories',
      href: 'directory/categories',
      icon: <IconCategory2 size={18} />,
      order: 2,
    },
    {
      uid: attributeModuleKey,
      title: 'Attributes',
      href: 'directory/attributes',
      icon: <IconAdjustments size={18} />,
      order: 2,
    },
    {
      uid: productModelModuleKey,
      title: 'model',
      href: 'directory/models',
      icon: <IconHexagons size={18} />,
      order: 3,
    },
    {
      uid: deviceModelModuleKey,
      title: 'Device Model',
      href: 'directory/device-model',
      icon: <IconDevices size={18} />,
      order: 4,
    },
    {
      uid: providerModuleKey,
      title: 'Providers',
      href: 'directory/providers',
      icon: <IconShieldChevron size={18} />,
      order: 5,
    },
  ],
}

export default [
  editCategoryRoute,
  createCategoryRoute,
  categoriesRoute,
  brandRoute,
  createBrandRoute,
  editBrandRoute,
  attributeRoute,
  createAttributeRoute,
  editAttributeRoute,
  modelRoute,
  providerRoute,
  deviceModel,
]
